import * as React from "react";
const SvgFlash = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.93 8.5h5.25l-6.75 9.75V11.5H4.18l6.75-9.75z" }));
export default SvgFlash;
